var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'reaction-icon': true,
        'hidden': _vm.amount < 1,
    },attrs:{"aria-label":_vm.ariaLabel,"data-amount":_vm.amount,"v-if":_vm.amount < 1},domProps:{"innerHTML":_vm._s(_vm.reactionIcons[_vm.reaction])},on:{"click":function($event){return _vm.$emit('open', _vm.reaction)}}})}
var staticRenderFns = []

export { render, staticRenderFns }